import { render, staticRenderFns } from "./VendorSourcing.vue?vue&type=template&id=1ab6dd34"
import script from "./VendorSourcing.vue?vue&type=script&lang=js"
export * from "./VendorSourcing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports